import React from 'react';
import { GiftOutlined, TrophyOutlined, NominationOutlined } from '@ant-design/icons';

import CustomCards from './CutomCards.jsx';

import { ReactComponent as PointsToSendIcon } from './../../../assets/svg/pointstosend.svg';
import { ReactComponent as RecipientIcon } from './../../../assets/svg/recipientOne.svg';
import { ReactComponent as RewardIcon } from './../../../assets/svg/rewardOne.svg';

import './style.scss';

const RewardPointsAndBonus = (props) => {
	const { rewardPointsBonus, isRecognitionMode, recognitionTotals } = props;
	
	if (isRecognitionMode && recognitionTotals) {
		return (
			<div className="rewards-points d-card height-equal">
				<div className="d-card-head">
					<h4 className="d-title-no-case">My Totals</h4>
				</div>
				<div className="reward-point-boxes">
					<CustomCards
						Icon={RewardIcon}
						customCardsClassName="reward-bonus"
						cardColor="#e75da7"
						pointAmount={recognitionTotals?.recognitions || 0}
						cardTitle={recognitionTotals?.recognitions === 1 ? 'Recognition' : 'Recognitions'}
					/>
					<CustomCards
						Icon={PointsToSendIcon}
						cardColor="#14D6D3"
						customCardsClassName="reward-bonus"
						pointAmount={recognitionTotals?.nominations || 0}
						cardTitle={recognitionTotals?.nominations === 1 ? 'Nomination' : 'Nominations'}
					/>
					<CustomCards
						Icon={() => <GiftOutlined style={{ fontSize: '3rem', color: 'white' }} />}
						cardColor="#813ae2"
						customCardsClassName="reward-bonus"
						pointAmount={recognitionTotals?.gifts || 0}
						cardTitle={recognitionTotals?.gifts === 1 ? 'Gift' : 'Gifts'}
					/>
				</div>
			</div>
		);
	}
	
	return (
		<div className="rewards-points d-card height-equal">
			<div className="d-card-head">
				<h4 className="d-title-no-case">My Totals</h4>
			</div>
			<div className="reward-point-boxes">
				<CustomCards
					Icon={PointsToSendIcon}
					customCardsClassName="reward-bonus"
					cardColor="#14D6D3"
					pointAmount={rewardPointsBonus?.totalEarned}
					cardTitle={'Total Points'}
				/>
				<CustomCards
					Icon={RewardIcon}
					cardColor="#e75da7"
					customCardsClassName="reward-bonus"
					pointAmount={rewardPointsBonus?.badges}
					cardTitle={rewardPointsBonus?.badges === 1 ? 'Recognition' : 'Recognitions'}
				/>
				<CustomCards
					Icon={RecipientIcon}
					cardColor="#813ae2"
					customCardsClassName="reward-bonus"
					pointAmount={rewardPointsBonus?.shoutOuts}
					cardTitle={rewardPointsBonus?.shoutOuts === 1 ? 'Mention' : 'Mentions'}
				/>
			</div>
		</div>
	);
};

export default RewardPointsAndBonus;
